// 导入vuex
import store from '@/store'

export const getThemeCluster = (theme) => {
  const tintColor = (color, tint) => {
    let red = parseInt(color.slice(0, 2), 16)
    let green = parseInt(color.slice(2, 4), 16)
    let blue = parseInt(color.slice(4, 6), 16)

    if (tint === 0) {
      return [red, green, blue].join(',')
    } else {
      red += Math.round(tint * (255 - red))
      green += Math.round(tint * (255 - green))
      blue += Math.round(tint * (255 - blue))

      red = red.toString(16)
      green = green.toString(16)
      blue = blue.toString(16)

      return `#${red}${green}${blue}`
    }
  }

  const shadeColor = (color, shade) => {
    let red = parseInt(color.slice(0, 2), 16)
    let green = parseInt(color.slice(2, 4), 16)
    let blue = parseInt(color.slice(4, 6), 16)

    red = Math.round((1 - shade) * red)
    green = Math.round((1 - shade) * green)
    blue = Math.round((1 - shade) * blue)

    red = red.toString(16)
    green = green.toString(16)
    blue = blue.toString(16)

    return `#${red}${green}${blue}`
  }

  const clusters = [theme]
  for (let i = 0; i <= 9; i++) {
    clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
  }
  clusters.push(shadeColor(theme, 0.1))
  return clusters
}

// 初始化主题
export const initTheme = () => {
  const theme = localStorage.getItem('COLOR_THEME')
    ? localStorage.getItem('COLOR_THEME')
    : '#409EFF'
  const themeRefresh = getThemeCluster(theme.replace('#', ''))
  store.dispatch('theme/setThemeColor', themeRefresh)
}

export const isChangeTheme = (val, num) => {
  return new Promise((resolve, reject) => {
    // let ORIGINAL_THEME = localStorage.getItem('COLOR_THEME') ? localStorage.getItem('COLOR_THEME') : '#409EFF'
    const ORIGINAL_THEME = '#409EFF'
    let theme = ORIGINAL_THEME
    // const version = '2.12.0'
    window.chalk = ''

    // 主题变更
    function changeTheme(val = theme, oldVal = ORIGINAL_THEME) {
      if (typeof val !== 'string') return
      const themeCluster = getThemeCluster(val.replace('#', ''))
      const originalCluster = getThemeCluster(oldVal.replace('#', ''))

      const getHandler = (variable, id) => {
        return () => {
          const newStyle = updateStyle(
            window.chalk,
            originalCluster,
            themeCluster
          )

          let styleTag = document.getElementById(id)
          if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.setAttribute('id', id)
            document.head.appendChild(styleTag)
          }
          styleTag.innerText = newStyle
          // store.commit('theme/SET_ORIGIN', originalCluster)
          store.dispatch('theme/setThemeColor', themeCluster)
          // store.dispatch('theme/setThemeCluster', themeCluster)
          localStorage.setItem('COLOR_THEME', theme)
          resolve()
        }
      }

      const chalkHandler = getHandler('chalk', 'chalk-style')

      if (!window.chalk) {
        const blackUrl = `${location.origin}/theme/index.css`
        const url = `${location.origin}/theme/eheme-chalk-index.css`
        // const url = 'https://cdn.jsdelivr.net/npm/element-ui@2.12.0/lib/theme-chalk/index.css'
        getCSSString(num === 2 ? blackUrl : url, chalkHandler, 'chalk')
      } else {
        chalkHandler()
      }
      // console.log('默认老的颜色：',oldVal)
      // 更改style里面的color
      const styles = [].slice
        .call(document.querySelectorAll('style'))
        .filter((style) => {
          const text = style.innerText
          return (
            new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
          )
        })
      // console.log('取默认主题色样式：',styles)
      styles.forEach((style) => {
        const { innerText } = style
        if (typeof innerText !== 'string') return
        style.innerText = updateStyle(innerText, originalCluster, themeCluster)
        // console.log('所传的参数innerText, originalCluster, themeCluster：', originalCluster, themeCluster)
        // 响应外部操作
      })
      // console.log('换过颜色之后的主题色：',styles)
      // 响应外部操作
      // $emit('onThemeChange', val)
    }

    // 用户改变主题
    function userChangeColor(color) {
      if (color) {
        theme = color
        changeTheme()
        return
      }
      theme = ORIGINAL_THEME
      changeTheme()
    }

    // 更新主题style
    function updateStyle(style, oldCluster, newCluster) {
      let newStyle = style
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
      })
      return newStyle
    }

    // 重现获取远程ele样式
    function getCSSString(url, callback, variable) {
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          window.chalk = xhr.responseText.replace(/@font-face{[^}]+}/, '')
          callback()
        }
      }
      xhr.open('GET', url, true)
      xhr.send()
    }

    // 执行换肤
    userChangeColor(val || '')
  })
}
export const updateNewPageCss = () => {
  return new Promise((resolve, reject) => {
    const ORIGINAL_THEME = '#409EFF'
    // const theme = ORIGINAL_THEME
    // 更新主题style
    function updateStyle(style, oldCluster, newCluster) {
      let newStyle = style
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
      })
      return newStyle
    }

    // 单独更新新加载CSS
    function updateNewPageCss() {
      const color = localStorage.getItem('COLOR_THEME')
        ? localStorage.getItem('COLOR_THEME')
        : '#409EFF'
      const themeCluster = getThemeCluster(color.replace('#', ''))
      const originalCluster = getThemeCluster(ORIGINAL_THEME.replace('#', ''))
      // 更改style里面的color
      const styles = [].slice
        .call(document.querySelectorAll('style'))
        .filter((style) => {
          const text = style.innerText
          return (
            new RegExp(ORIGINAL_THEME, 'i').test(text) &&
            !/Chalk Variables/.test(text)
          )
        })

      // console.log('单独加载主题色：',styles)
      styles.forEach((style) => {
        const { innerText } = style
        if (typeof innerText !== 'string') return
        style.innerText = updateStyle(innerText, originalCluster, themeCluster)

        // console.log('所传的参数 originalCluster, themeCluster：', originalCluster, themeCluster)
      })
      // console.log('单独加载换过颜色之后的主题色：',styles)
    }
    updateNewPageCss()
  })
}
